import { connect } from 'react-redux'
import {
  selectCollectionById,
  selectItemAndGroupIds,
  selectOpenCollectionIds,
} from 'ducks/folders/selectors/collections'
import { doOpenOneCollection } from 'ducks/folders/operations/collections'
import FoldersView from './view'

const select = (state, props) => {
  const { collectionId } = props
  const { id, name, color, queryId, linkTo } = selectCollectionById(
    state,
    collectionId
  )
  const openCollectionIds = selectOpenCollectionIds(state)
  return {
    name,
    color,
    queryId,
    linkTo,
    open: openCollectionIds.includes(id),
    itemAndGroupIds: selectItemAndGroupIds(state, collectionId),
    hideName: false,
  }
}

const perform = {
  onClick: (id, evt) => doOpenOneCollection({ collectionId: id, event: evt }),
}

export default connect(select, perform)(FoldersView)
